<template>
    <div :class="cardClasses">
        <div>
            <ImageCard
                v-bind="bindings"
                :image="image"
                :imageAlt="imageAlt"
                :imageAspectRatio="imageAspectRatio"
                :imageObjectFit="imageObjectFit"
                :imageObjectPosition="imageObjectPosition"
                :imageOverlayLocked="imageOverlayLocked"
                :imageLoading="imageLoading"
                :fetchPriority="fetchPriority"
                :roundedTop="true"
            />
            <div class="p-4">
                <ContentCardHeading
                    :heading="heading"
                    heading-color="text-white"
                    :truncated="false"
                    :headingComponent="headingComponent"
                    :dark="dark"
                    margin-bottom="mb-1"
                />
                <ContentCardText v-if="excerpt" :html="excerpt" :dark="true" content-color="text-sky-300 italic font-medium" class="mb-2"/>
                <ContentCardText v-if="content" :html="content" :dark="true" content-color="text-white font-normal" class="mb-2" />
                <ButtonRegular
                    v-if="buttonText && (route || href)"
                    :buttonRoute="route"
                    :buttonHref="href"
                    :buttonText="buttonText"
                    class="mt-2.5 block w-full py-2 px-4 rounded-lg text-center hover:bg-orange-700 "
                    buttonColor="bg-orange-800 text-white hover:bg-orange-700 focus-visible:outline-amber-600 text-sm lg:text-lg transition-colors"
                ></ButtonRegular>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'LayoutHoverCard',
    props: {
        route: {
            required: false,
            type: [String, Object],
            default: null,
        },
        href: {
            required: false,
            type: String,
        },
        target: {
            required: false,
            type: String,
            default: null,
        },
        heading: {
            required: false,
            type: String,
            default: null,
        },
        headingComponent: {
            required: false,
            type: String,
            default: 'p',
        },
        excerpt: {
            required: false,
            type: String,
            default: null,
        },
        textCentered: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
        image: {
            required: false,
            type: String,
            default: null,
        },
        imageAlt: {
            required: false,
            type: String,
            default: '',
        },
        imageAspectRatio: {
            required: false,
            type: String,
            default: null,
        },
        imageObjectFit: {
            required: false,
            type: String,
            default: 'object-cover',
        },
        imageObjectPosition: {
            required: false,
            type: String,
            default: 'center',
        },
        imageOverlayLocked: {
            required: false,
            type: [Boolean, Number],
            default: null,
        },
        imageLoading: {
            required: false,
            type: String,
            default: undefined,
        },
        fetchPriority: {
            required: false,
            type: [String, undefined],
            default: undefined,
        },
        dark: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
        buttonText: {
            required: true,
            type: String,
        },
        content: {
            required: false,
            type: String,
            default: null,
        },
    },
    computed: {
        bindings () {
            const bindings = {};
            if (this.route) bindings.route = this.route;
            if (this.href) bindings.href = this.href;
            return bindings;
        },
        cardClasses () {
            const cls = {};
            cls['HoveredCard col-span-1 flex flex-col divide-y rounded-lg overflow-hidden shadow-xl bg-zinc-900 bg-opacity-95'] = true;
            cls['text-center'] = !!this.textCentered;
            return cls;
        },
    },
};
</script>
